var heading_default = {
  "fontElementMap": "DcyVW",
  "elementSpacing": "NfA7j",
  "headerOne": "_9Dsuo NfA7j",
  "headerTwo": "_6Aw8R NfA7j",
  "headerThree": "qAx9- NfA7j",
  "headerFour": "BmTdM NfA7j",
  "headerFive": "lWgvw NfA7j",
  "headerSix": "ORfsN NfA7j",
  "child": "KfHkb"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
